// Drives the header's dark/light switch. Dark is the stylesheet default, so
// there is nothing to do on load — a click just adds or removes
// data-theme="light" on <html>. Deliberately not persisted: every page load
// starts dark.
const LIGHT = "light"
const root = document.documentElement

function apply(theme) {
  if (theme === LIGHT) {
    root.dataset.theme = LIGHT
  } else {
    delete root.dataset.theme
  }

  const label = theme === LIGHT ? "Switch to dark theme" : "Switch to light theme"
  document.querySelectorAll("[data-theme-toggle]").forEach((button) => {
    button.setAttribute("aria-label", label)
    button.title = label
  })
}

// Delegated so the handler survives live reload swapping the header out.
document.addEventListener("click", (event) => {
  if (!event.target.closest("[data-theme-toggle]")) return
  apply(root.dataset.theme === LIGHT ? "dark" : LIGHT)
})
